module.exports = __webpack_public_path__ + "static/media/pinning_bouttennier.d93a424a.jpg";